<template>
  <div class="home">
    <header class="home-header">
      <img src="/images/gardens/Ogrod_Swiatel_logo_vector_1line_white.svg" alt="Ogród Świateł" width="280" />
      <nav aria-label="Language"><router-link to="/pl" lang="pl">PL</router-link> · <router-link to="/en" lang="en">EN</router-link></nav>
      <h1>{{ english ? 'Choose your Garden of Lights' : 'Wybierz swój Ogród Świateł' }}</h1>
    </header>
    <GardensAll :items="gardens" />
    <footer class="home-footer">
      <section class="company-details" :aria-label="english ? 'Organiser details' : 'Dane organizatora'">
        <h2>{{ english ? 'Organiser details' : 'Dane organizatora' }}</h2>
        <div class="company-details-content">
          <address>
            <strong>PYNI Sp. z o.o.</strong><br />
            ul. Gdyńska 107<br />
            80-209 Chwaszczyno
          </address>
          <div>
            NIP: 7292570758<br />
            KRS: 0000230631<br />
            REGON: 473284181
          </div>
          <div>
            E-mail: <a href="mailto:kontakt@ogrodswiatel.pl">kontakt@ogrodswiatel.pl</a><br />
            {{ english ? 'Phone' : 'Telefon' }}: <a href="tel:+48502562497">+48 502 562 497</a>
          </div>
        </div>
      </section>
      <nav :aria-label="english ? 'Documents' : 'Dokumenty'">
        <a href="/docs/pyni/polityka-prywatnosci.pdf" target="_blank" rel="noopener">
          {{ english ? 'Privacy policy' : 'Polityka prywatności' }}
        </a>
        <a href="/docs/pyni/regulamin-sprzedazy-biletow.pdf" target="_blank" rel="noopener">
          {{ english ? 'Online ticket sales terms' : 'Regulamin sprzedaży biletów online' }}
        </a>
      </nav>
    </footer>
  </div>
</template>

<script>
import GardensAll from '@/components/garden-of-lights/GardensAll.vue';
import {getLandingPageSettings} from '@/scripts/settings';
const banners = [
  ['kalisz', 'Kalisz'], ['olsztyn', 'Olsztyn'], ['rzeszow', 'Rzeszów'],
  ['skarzysko-kamienna', 'Skarżysko-Kamienna'], ['slupsk', 'Słupsk'], ['zielona-gora', 'Zielona Góra'],
];
export default {
  components: {GardensAll},
  data: () => ({availableGardens: []}),
  computed: {
    english() { return this.$route.params.lang === 'en'; },
    gardens() {
      return this.availableGardens.map(item => ({
        ...item,
        url: '/' + (item.languages.available.includes(this.$route.params.lang)
            ? this.$route.params.lang : item.languages.default) + '/' + item.slug,
      }));
    },
  },
  watch: {
    english: {immediate: true, handler(value) {
      document.title = value ? 'Garden of Lights — magical illuminations' : 'Ogród Świateł — magiczne iluminacje';
    }},
  },
  async mounted() {
    const results = await Promise.all(banners.map(async ([slug, title]) => {
      try {
        const settings = await getLandingPageSettings(slug);
        if (!settings || settings.enabled === false || !settings.languages) return null;
        return {slug, title, src: '/images/home/' + slug + '.png', languages: settings.languages};
      } catch (_) { return null; }
    }));
    this.availableGardens = results.filter(Boolean);
  },
};
</script>

<style scoped>
.home { min-height: 100vh; background: #241039; }
.home-header { text-align: center; padding: 48px 20px 0; }
.home-header img { max-width: 75%; height: auto; }
.home-header nav { margin: 24px 0; color: white; }
.home-header a { color: #fff7a2; padding: 8px; }
.home-header h1 { font-size: clamp(24px, 4vw, 40px); color: white; margin-bottom: 0; }
.home-footer { max-width: 1240px; margin: 0 auto; padding: 0 20px 40px; }
.home-footer nav { display: flex; flex-wrap: wrap; justify-content: center; gap: 8px 24px; }
.home-footer nav a { color: #fff7a2; padding: 8px; text-align: center; text-decoration: underline; }
.home-footer nav a:hover, .home-footer nav a:focus-visible { color: white; }
.home-footer nav a:focus-visible { outline: 2px solid currentColor; outline-offset: 4px; }
.company-details {
  padding: 28px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
  color: white;
  font-size: 16px;
  line-height: 1.75;
}
.company-details h2 { margin-bottom: 20px; color: white; font-size: 24px !important; line-height: 1.4; text-shadow: none; }
.company-details-content { display: flex; flex-wrap: wrap; gap: 20px 48px; }
.company-details address { font-style: normal; }
.company-details a { color: #fff7a2; text-decoration: underline; overflow-wrap: anywhere; }
.company-details a:hover, .company-details a:focus-visible { color: white; }
.company-details a:focus-visible { outline: 2px solid currentColor; outline-offset: 4px; }
</style>
